import { ICatalog } from "../store/catalog/repository/ICatalog";
import i18n from "../locales";

function findCategoryPathById(
  categories: ICatalog[],
  targetId: number,
  path: ICatalog[] = [],
): ICatalog[] | null {
  for (const category of categories) {
    const currentPath = [...path, category];

    if (category.id === targetId) {
      return currentPath;
    }

    if (category.childCategories?.length) {
      const result = findCategoryPathById(
        category.childCategories,
        targetId,
        currentPath,
      );

      if (result) return result;
    }
  }

  return null;
}

export const breadcrumbsItems = (catalog: ICatalog[], numericId: number) => {
  if (!numericId) return [{ label: i18n.t("home"), to: "/" }];

  const path = findCategoryPathById(catalog, numericId);

  if (!path) return [{ label: i18n.t("home"), to: "/" }];
  return [
    { label: i18n.t("home"), to: "/" },
    ...path
      .filter((cat) => cat.name && !cat.isHidden)
      .map((cat) => ({
        label: cat.name!,
        to: `/categories/${cat.id}`,
      })),
  ];
};
